import React from 'react';

export const Knockout_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Knockout</span>,
  },
];

export const Lux_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Ópticas Lux</span>,
  },
];

export const Puma_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Puma</span>,
  },
];

export const Pirma_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>PIRMA</span>,
  },
];

export const Interceramic_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Interceramic</span>,
  },
];

export const Betcris_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Betcris</span>,
  },
];

export const Coca_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Coca-Cola</span>,
  },
];

export const Cineminuto_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Cineminuto</span>,
  },
];

export const Lg_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>LG</span>,
  },
];

export const Excelsior_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Excélsior</span>,
  },
];

export const Rmx_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Rmx</span>,
  },
];

export const Mapaton_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Mapatón</span>,
  },
];
